import React from "react";
import MaterialIcon from "../../../components/BuilderComponents/MaterialIcon";
import { getFieldIcon } from "../../../utils/getFieldIcon";
import ToolBox from "./ToolBox";

const NodeContent = ({
  node,
  selectedItem,
  path,
  duplicateElement,
  copyElement,
  pasteElement,
  deleteElement,
  cutElement
}) => {
  const isSelected = selectedItem?.id === node.id;

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        flex: 1,
        gap: "4px",
        color: isSelected ? "#0057b8" : "#333"
      }}
    >
      <NodeLabel node={node} />
      {isSelected && (
        <ToolBox
          selectedItem={selectedItem}
          onDuplicate={(el) => duplicateElement(el, { path })}
          onCopy={copyElement}
          onPaste={(el) => pasteElement(el, { path })}
          onDelete={(el) => deleteElement(el, { path })}
          onCut={(el) => cutElement(el, { path })}
        />
      )}
    </div>
  );
};

const getNodeTitle = (node) => {
  if (!node) return "";

  switch (node.type) {
    case "element":
      switch (node.config.type) {
        case "label":
          return node.config.name;
        case "field":
          return node.config.display;
        case "form-field":
          return node.config.field.label;
        default:
          return node.config?.name || node.config?.type || "Unnamed Element";
      }
    default:
      return node.type || node.name || "Untitled";
  }
};

const NodeLabel = ({ node }) => {
  if (!node) return null;

  return (
    <div className="d_flex align_center gap_2">
      <MaterialIcon
        name={getFieldIcon((node.config && node.config.type) || node.type)}
        style={{ fontSize: "16px", color: "#888888" }}
      />
      <span className="font_weight_medium font_size_small">{getNodeTitle(node)}</span>
    </div>
  );
};

export default NodeContent;
